export default __webpack_public_path__ + "static/skyoffice-e6bece379953c74358cc13f563ace4ce.png";